import { nanoid } from "nanoid";
import { FetchError } from "../../api/helpers/helpers";
export function createAsyncActions(payloadCreator, extra) {
    const abortRef = { current: null };
    const abort = () => {
        abortRef.current?.();
    };
    const action = (params, options) => {
        const requestId = options?.requestId || nanoid();
        let controller = new AbortController();
        extra?.action?.(params, options?.status, requestId);
        payloadCreator(params, { signal: controller.signal })
            .then((result) => {
            extra?.fulfilled?.(result, params, requestId);
        })
            .catch((error) => {
            if (error instanceof FetchError && error.message === "The user aborted a request.") {
                extra?.abort?.(params, requestId);
            }
            else if (error instanceof FetchError) {
                extra?.rejected?.(params, error.message, error, requestId);
            }
            else if (error instanceof Error) {
                extra?.rejected?.(params, error.message, undefined, requestId);
            }
            else {
                extra?.rejected?.(params, "Unknown Failure", undefined, requestId);
            }
        })
            .finally(() => {
            controller = null;
            abortRef.current = null;
            if (extra?.resolved) {
                extra?.resolved?.(params, requestId);
            }
        });
        const abort = () => {
            if (controller) {
                controller.abort();
            }
            controller = null;
        };
        abortRef.current = abort;
        return abort;
    };
    return { action, abort };
}
